(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[91],{

/***/ 36927:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications/[slug]",
      function () {
        return __webpack_require__(34970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_cvApplications_view_CVApplicationViewComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62659);
/* harmony import */ var components_shared_HeadMetadata__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73412);
/* harmony import */ var components_shared_Spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(594);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23357);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39105);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var services_manfredite_job_application_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72971);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62177);












var CVApplicationViewPage = function(param) {
    var slug = param.slug;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_5__/* .useI18n */ .Q)("cv-applications-view").t;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)(), push = ref.push, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_4__/* .LoggedUserContext */ .Vi), user = ref1.user, loadingUser = ref1.loadingUser;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), data = ref2[0], setData = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var jobApp, ex;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!loadingUser) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            services_manfredite_job_application_service__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getBySlug */ .Z.getBySlug(slug, user === null || user === void 0 ? void 0 : user.id)
                        ];
                    case 2:
                        jobApp = _state.sent();
                        setData(jobApp);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        push((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_9__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_9__/* .APP_URLS.cvApplicationNoPermission */ .uu.cvApplicationNoPermission, locale));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        slug,
        locale,
        push,
        user === null || user === void 0 ? void 0 : user.id,
        loadingUser
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_HeadMetadata__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: t("cvApplicationsView.pageTitle")
            }),
            !data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Spinner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_cvApplications_view_CVApplicationViewComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                slug: slug,
                jobApplicationResume: data.jobApplicationResume,
                termsAndConditionsAccepted: !!data.publicManfredite,
                cvApplication: data.jobApplication,
                publicManfredite: data.publicManfredite
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CVApplicationViewPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,6129,8746,9001,1122,2818,4511,9161,9092,5634,632,9774,2888,179], function() { return __webpack_exec__(36927); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);